import apiService from "../../api/api.service";
import { AccountMenuResponse, HeaderAccountMenuResponse } from "./accountMenu.types";

export const fetchAccountMenu = () => {
  return apiService.get<AccountMenuResponse>("/general/account-menu");
};

export const fetchHeaderAccountMenu = () => {
  return apiService.get<HeaderAccountMenuResponse>("/general/header-account-menu");
};
